import request from './request'

export function reportByBrand(params) {
  return request({ url: '/api/reports/by-brand', method: 'get', params })
}

export function reportByItemNo(params) {
  return request({ url: '/api/reports/by-item-no', method: 'get', params })
}

export function reportByMonth(params) {
  return request({ url: '/api/reports/by-month', method: 'get', params })
}
